
/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareEntity({
    entity: "libraryDefVersions",
    graphQL: "LibraryDefVersion",
    name: "Library Definition Version",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    optimizeReading: true,
    defaultOrder: [['createdAt', 'DESC']],
    fields: (types) => { return {
        id: {
            name: "Library Definition Version ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            isPublic: true,
            required: true,
            userEditable: false,
        },
        libraryDef: {
            name: "Library Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            hiddenCreate: true,
        },
        inChangeLog: {
            name: "In Change Log",
            type: "enum",
            defaultValue: "-",
            filterable: true,
            values: {
                "-": {
                    name: "Not decided yet",
                },
                "yes": {
                    name: "Yes",
                },
                "no": {
                    name: "No",
                },
            },
        },
        changeType: {
            name: "Change Type",
            type: "enum",
            values: {
                "feature": {
                    name: "Feature",
                },
                "improvement": {
                    name: "Improvement",
                },
                "bug": {
                    name: "Bug fix",
                },
                "critical-bug": {
                    name: "Critical bug fix",
                },
                "other": {
                    name: "Other",
                },
            },
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        title: {
            name: "Change Title",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        description: {
            name: "Change Description",
            type: "text",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        commitDescription: {
            name: "Commit Description",
            type: "text",
            defaultValue: "",
        },
        gitTag: {
            name: "Git sha",
            type: "string",
        },
        gitAuthorName: {
            name: "Git Author Name",
            type: "string",
        },
        gitAuthorEmail: {
            name: "Git Author e-mail",
            type: "string",
        },
        libraryDefContent: {
            name: "Library Definition Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        libraryDefContentGit: {
            name: "Content (GIT)",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            offload: true,
            import: false,
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
